import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AccountModel } from '../../../api/models/account-model';
import { AccountStateService } from '../../../services/account-state.service';
import { AuthService } from '../../../services/auth.service';
import { DialogService } from '../../../services/dialog.service';
import { SwitchModalComponent } from './switch-modal/switch-modal.component';
import { UserService } from '../../../api/services/user.service';
import { ToastService } from '../../../services/toast.service';
import { Router } from '@angular/router';

/**
 * Component allowing user to see their currently active account, as well as giving them the ability to switch their
 * active account, or create a new account
 */
@Component({
  selector: 'app-account-select',
  templateUrl: './account-select.component.html',
  standalone: false,
})
export class AccountSelectComponent implements OnInit {
  @Output() accountSwitched = new EventEmitter<AccountModel>();

  account: AccountModel | undefined = undefined;

  constructor(
    private accountStateService: AccountStateService,
    private authService: AuthService,
    private dialogService: DialogService,
    private userService: UserService,
    private toastService: ToastService,
    private router: Router,
  ) {}

  async ngOnInit() {
    // Set currently selected account
    this.account = await this.accountStateService.getAccount();
  }

  onClickNew() {
    void this.router.navigate(['admin', 'register'], {
      state: { isExistingUser: true },
    });
  }

  onClickSwitch() {
    const dialogRef = this.dialogService.openDialog(SwitchModalComponent, {
      availableAccounts: this.accountStateService.availableAccounts.value(),
    });

    dialogRef.componentInstance.accountSwitched.subscribe((account) => {
      this.account = account;
      this.userService
        .userSwapAccount$Response(
          {
            userGuid: this.authService.getUserGuid()!,
            body: {
              accountGuid: account.guid,
            },
          },
          this.authService.getAuthorisationHeaders(),
        )
        .subscribe({
          next: () => {
            this.toastService.success('Swapped Account');
            this.authService.setActiveAccountGuid(account.guid);
            this.accountSwitched.emit(account);
          },
        });
    });
  }
}
